import MultiTagInput from './MultiTagInput';

export default MultiTagInput;
